import { render, staticRenderFns } from "./loadingScreen.vue?vue&type=template&id=9ed6cc3e&scoped=true&"
import script from "./loadingScreen.vue?vue&type=script&lang=js&"
export * from "./loadingScreen.vue?vue&type=script&lang=js&"
import style0 from "./loadingScreen.vue?vue&type=style&index=0&id=9ed6cc3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed6cc3e",
  null
  
)

export default component.exports